import { setCountdown } from './state';
import { Duration } from 'luxon';
const leftFill = (num, width = 2) => {
    return Math.abs(num).toString(10).padStart(width, '0');
};
const fixupTimeremaining = (v) => {
    let isNeg = false;
    const parts = v.split(':').map((n) => +n);
    parts.forEach((n) => (isNeg = isNeg || n < 0));
    const vv = `T${parts.map((n) => leftFill(n)).join(':')}`;
    return [isNeg, vv];
};
export class Countdown {
    handle = 0;
    tick;
    running = false;
    store;
    bufferMinutes = 0;
    onBufferExpired = null;
    constructor(timeremaining, store, bufferMinutes = 0, onBufferExpired) {
        this.store = store;
        this.bufferMinutes = bufferMinutes;
        this.onBufferExpired = onBufferExpired || null;
        if (timeremaining === undefined || timeremaining === null) {
            timeremaining = '00:00:00';
        }
        if (typeof timeremaining === 'string') {
            const [isNeg, remaining] = fixupTimeremaining(timeremaining);
            this.tick = Duration.fromISOTime(remaining).normalize();
            if (isNeg) {
                this.tick = this.tick.negate();
            }
            const { hours = 0, minutes = 0, seconds = 0 } = this.tick.toObject();
            console.log(`timeremaining: ${isNeg ? '-' : ''}${remaining}; tick (Duration) = ${hours}:${minutes}:${seconds}
				})}`);
        }
        else {
            this.tick = Duration.fromObject(timeremaining).normalize();
            const { hours = 0, minutes = 0, seconds = 0 } = this.tick.toObject();
            console.log(`timeremaining: ${timeremaining.hours || 0}:${timeremaining.minutes || 0}:${timeremaining.seconds || 0}; tick (Duration) = ${hours}:${minutes}:${seconds}
				})}`);
        }
    }
    set timeremaining(val) {
        const running = this.running;
        running && this.stop();
        if (typeof val === 'string') {
            const [isNeg, remaining] = fixupTimeremaining(val);
            this.tick = Duration.fromISOTime(remaining).normalize();
            if (isNeg) {
                this.tick = this.tick.negate();
            }
            const { hours = 0, minutes = 0, seconds = 0 } = this.tick.toObject();
            console.log(`timeremaining: ${isNeg ? '-' : ''}${remaining}; tick (Duration) = ${hours}:${minutes}:${seconds}
			})}`);
        }
        else {
            this.tick = Duration.fromObject(val).normalize();
            const { hours = 0, minutes = 0, seconds = 0 } = this.tick.toObject();
            console.log(`timeremaining: ${val.hours || 0}:${val.minutes || 0}:${val.seconds || 0}; tick (Duration) = ${hours}:${minutes}:${seconds}
				})}`);
        }
        running && this.start();
    }
    get duration() {
        return this.tick;
    }
    stop() {
        if (this.running) {
            clearInterval(this.handle);
        }
        this.running = false;
        this.handle = 0;
    }
    start() {
        if (this.running) {
            return;
        }
        this.running = true;
        const updateTimer = () => {
            this.tick = this.tick.minus(1000).normalize();
            const { hours = 0, minutes = 0, seconds = 0 } = this.tick.toObject();
            const isNeg = this.tick.valueOf() < 0;
            if (isNeg && this.bufferMinutes > 0 && this.onBufferExpired) {
                const negativeMinutes = Math.abs(this.tick.as('minutes'));
                if (negativeMinutes >= this.bufferMinutes) {
                    this.stop();
                    this.onBufferExpired();
                    return;
                }
            }
            const sign = isNeg ? '-' : '';
            const hrs = hours !== 0 ? `${Math.abs(hours)}:` : '';
            const min = leftFill(minutes, hours !== 0 ? 2 : 1);
            const sec = leftFill(Math.floor(seconds), 2);
            const countdown = `${sign}${hrs}${min}:${sec}`;
            setCountdown(this.store)({ countdown });
        };
        this.handle = setInterval(updateTimer, 1000);
    }
}
